// Design 9: Horizontal Scroll - Creative
import { motion } from 'framer-motion';

export default function Design9({ logo }: { logo: string }) {
  return (
    <div className="min-h-screen bg-[#F5F5F0]">
      <nav className="fixed top-0 w-full z-50 mix-blend-difference">
        <div className="max-w-7xl mx-auto px-6 py-6 flex justify-between items-center">
          <img src={logo} alt="Froma" className="h-8 invert" />
          <a href="/login" className="text-white text-sm">Login →</a>
        </div>
      </nav>

      <section className="min-h-screen flex items-center">
        <div className="w-full px-6">
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="max-w-7xl mx-auto">
            <h1 className="text-[12vw] font-bold text-gray-900 leading-none tracking-tighter">
              FROMA
            </h1>
            <div className="mt-8 flex gap-8 text-gray-600">
              <span>Fragrances</span>
              <span>•</span>
              <span>Flavors</span>
              <span>•</span>
              <span>Since 1996</span>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-24 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-8 overflow-x-auto pb-8 scrollbar-hide">
            {[
              { title: 'Fine Perfumery', num: '01' },
              { title: 'Food Flavors', num: '02' },
              { title: 'Essential Oils', num: '03' },
              { title: 'Custom Solutions', num: '04' },
            ].map(c => (
              <div key={c.num} className="flex-shrink-0 w-80 bg-gray-800 p-8 rounded-xl">
                <div className="text-orange-500 text-sm">{c.num}</div>
                <h3 className="mt-4 text-2xl text-white">{c.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-32 bg-orange-500 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl font-bold">Let's Create</h2>
          <p className="mt-6 text-white/80 text-lg">Transform your vision into sensory reality</p>
          <a href="mailto:info@froma.com.tr" className="inline-block mt-10 px-10 py-4 bg-white text-orange-500 font-semibold rounded-full hover:bg-gray-100 transition">
            Get Started
          </a>
        </div>
      </section>

      <footer className="py-8 bg-gray-900 text-center text-gray-500 text-sm">
        © {new Date().getFullYear()} Froma
      </footer>
    </div>
  );
}
